import { render, staticRenderFns } from "./PrevPageLink.vue?vue&type=template&id=43cfd378"
import script from "./PrevPageLink.vue?vue&type=script&lang=js"
export * from "./PrevPageLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports